import { useCallback } from "react";
import { useFetchAsync } from "../../../../hooks/useFetchAsync";
import axios from "../../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../../../../api/v1";

// ✅ API function
const fetchLeaseConfigTemplate = async () => {
  const orgData = localStorage?.getItem("login-response");
  const orgId = orgData ? JSON.parse(orgData) : null;
  const res = await axios.get(`${apiV1Endpoint}/organization/${orgId?.orgId}?filterkeys=leaseConfig`);
  return res.data;
};

// ✅ Custom hook
export const useGetConfig = () => {
  // useCallback ensures fetch function identity stays stable
  const fetchFn = useCallback(fetchLeaseConfigTemplate, []);

  // Call your reusable fetching hook
  const { data, isLoading, error } = useFetchAsync({ fetchFn });
  let template = data?.result?.leaseConfig || [];
  // ✅ Sort logic: text fields first, then switch & checkbox
  const leaseConfigTemplateData = [...template].sort((a, b) => {
    const order = { text: 1, select: 2, switch: 3, checkbox: 4 } as const;
    return order[a.type] - order[b.type];
  });
  return { data: leaseConfigTemplateData, isLoading, error };
};
